var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("div", { staticClass: "q-toolbar" }, [
        _c(
          "div",
          { staticClass: "q-toolbar-buttons" },
          [
            _c(
              "q-button",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.hasSelection,
                    expression: "hasSelection",
                  },
                ],
                staticClass: "q-toolbar-btn",
                style: _vm.firstButtonStyle,
                on: { click: _vm.replyTasks },
              },
              [
                _vm.multipleSelection && _vm.multipleSelection.length < 2
                  ? _c("font-awesome-icon", {
                      attrs: { icon: ["fas", "reply"] },
                    })
                  : _c("font-awesome-icon", {
                      attrs: { icon: ["fas", "reply-all"] },
                    }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "q-button",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.hasSelection,
                    expression: "hasSelection",
                  },
                ],
                staticClass: "q-toolbar-btn",
                on: { click: _vm.forwardTasks },
              },
              [
                _vm.multipleSelection && _vm.multipleSelection.length < 2
                  ? _c("font-awesome-icon", {
                      attrs: { icon: ["fas", "share"] },
                    })
                  : _c("font-awesome-icon", {
                      attrs: { icon: ["fas", "share"] },
                    }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "q-button",
              {
                staticClass: "q-toolbar-btn",
                on: {
                  click: function ($event) {
                    $event.preventDefault()
                    _vm.limitationDialog = true
                  },
                },
              },
              [_c("font-awesome-icon", { attrs: { icon: ["fas", "filter"] } })],
              1
            ),
            _vm._v(" "),
            _c(
              "q-button",
              { staticClass: "q-toolbar-btn", on: { click: _vm.refreshRows } },
              [
                _c("font-awesome-icon", {
                  attrs: { icon: ["fas", "sync-alt"] },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _vm.getPermissions("STRUCTURE")
              ? _c(
                  "q-button",
                  {
                    staticClass: "q-toolbar-btn",
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        _vm.structureDialog = true
                      },
                    },
                  },
                  [
                    _c("font-awesome-icon", {
                      attrs: { icon: ["fas", "cog"] },
                    }),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "q-dropdown",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.hasSelection,
                    expression: "hasSelection",
                  },
                ],
                staticClass: "q-toolbar-btn",
                attrs: { trigger: "click" },
                on: { command: _vm.runMethods },
              },
              [
                _c("q-button", [
                  _c("span", [
                    _vm._v(_vm._s(this.$qt("listStructure.actionCaption"))),
                  ]),
                  _vm._v(" "),
                  _c("i", { staticClass: "q-icon-arrow-down q-icon--right" }),
                ]),
                _vm._v(" "),
                _c(
                  "q-dropdown-menu",
                  { attrs: { slot: "dropdown" }, slot: "dropdown" },
                  _vm._l(_vm.listStructure.methods, function (method) {
                    return _c(
                      "q-dropdown-item",
                      { key: method.key, attrs: { command: method } },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(method.caption) +
                            "\n          "
                        ),
                      ]
                    )
                  }),
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "q-input",
              {
                style: _vm.searchStyle,
                attrs: {
                  placeholder: this.$qt("listStructure.searchPlaceHolder"),
                },
                model: {
                  value: _vm.word,
                  callback: function ($$v) {
                    _vm.word = $$v
                  },
                  expression: "word",
                },
              },
              [
                _c("q-button", {
                  attrs: {
                    slot: "append",
                    type: "info",
                    icon: "q-icon-search",
                  },
                  slot: "append",
                }),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c(
        "q-panel",
        [
          _c(
            "q-table",
            {
              attrs: {
                stripe: "",
                data: _vm.filteredData,
                width: _vm.listStructure.width,
                "sum-text": "----",
                "empty-text": this.$qt("listStructure.emptyList"),
              },
              on: {
                "row-click": _vm.rowSelected,
                "selection-change": _vm.handleSelectionChange,
              },
            },
            [
              _c("q-table-column", {
                attrs: { type: "selection", width: "55" },
              }),
              _vm._v(" "),
              _c("q-table-column", {
                attrs: {
                  property: "startTime",
                  sortable: "",
                  label: this.$qt("taskList.startTimeCaption"),
                  width: "200",
                },
              }),
              _vm._v(" "),
              _c("q-table-column", {
                attrs: { property: "loaded", width: "55" },
              }),
              _vm._v(" "),
              _vm._l(_vm.listStructure.columns, function (col) {
                return _c("q-table-column", {
                  key: col.key,
                  attrs: {
                    type: col.type,
                    sortable: col.sortable === true,
                    label: col.caption,
                    width: col.width === 0 ? undefined : col.width,
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            col.fieldType === "DatePicker"
                              ? [
                                  _c(
                                    "span",
                                    { staticStyle: { direction: "ltr" } },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.getDate(scope.row[col.key]))
                                      ),
                                    ]
                                  ),
                                ]
                              : col.fieldType === "CheckBox"
                              ? [
                                  scope.row[col.key] === true
                                    ? _c("font-awesome-icon", {
                                        attrs: { icon: "check" },
                                      })
                                    : _c("font-awesome-icon", {
                                        attrs: { icon: "times" },
                                      }),
                                ]
                              : col.fieldType === "model"
                              ? [_c("span", [_vm._v("AMIN")])]
                              : [
                                  _c("span", [
                                    _vm._v(_vm._s(scope.row[col.key])),
                                  ]),
                                ],
                          ]
                        },
                      },
                    ],
                    null,
                    true
                  ),
                })
              }),
            ],
            2
          ),
          _vm._v(" "),
          _c("q-pagination", {
            attrs: {
              "page-size": _vm.listStructure.itemInPage,
              "pager-count": 11,
              total: _vm.modelsQty,
              layout: "prev ,pager , next",
              "current-page": _vm.currentPage,
              "next-text": this.$qt("listStructure.pagination.nextText"),
              "prev-text": this.$qt("listStructure.pagination.prevText"),
              background: "",
            },
            on: {
              "update:currentPage": function ($event) {
                _vm.currentPage = $event
              },
              "update:current-page": function ($event) {
                _vm.currentPage = $event
              },
              "current-change": _vm.changePage,
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "q-dialog",
        {
          attrs: {
            title: this.$qt("listStructure.settingTitle"),
            width: "50%",
            visible: _vm.structureDialog,
          },
          on: {
            "update:visible": function ($event) {
              _vm.structureDialog = $event
            },
          },
        },
        [
          _c("list-structure-detail", {
            on: {
              close: function ($event) {
                _vm.structureDialog = false
              },
            },
            model: {
              value: _vm.listStructure,
              callback: function ($$v) {
                _vm.listStructure = $$v
              },
              expression: "listStructure",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "q-dialog",
        {
          attrs: {
            title: this.$qt("listStructure.limitationTitle"),
            width: "50%",
            visible: _vm.limitationDialog,
            "append-to-body": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.limitationDialog = $event
            },
          },
        },
        [
          _vm.limitationStructure
            ? _c(
                "div",
                [
                  _c(
                    "q-form",
                    {
                      ref: "limitationForm",
                      attrs: {
                        model: _vm.rangeModel,
                        rules: _vm.rangeRules,
                        "labq-width": "150px",
                      },
                    },
                    [
                      _c("q-form-generator", {
                        attrs: { "form-structure": _vm.limitationStructure },
                        model: {
                          value: _vm.rangeModel,
                          callback: function ($$v) {
                            _vm.rangeModel = $$v
                          },
                          expression: "rangeModel",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              )
            : _c("div", [
                _c("span", [
                  _vm._v(_vm._s(this.$qt("listStructure.limitationNotSet"))),
                ]),
              ]),
          _vm._v(" "),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "q-button",
                { attrs: { type: "primary" }, on: { click: _vm.limit } },
                [_vm._v(_vm._s(this.$qt("listStructure.confirmLimitation")))]
              ),
              _vm._v(" "),
              _c(
                "q-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.limitationDialog = false
                    },
                  },
                },
                [_vm._v(_vm._s(this.$qt("listStructure.rejectLimitation")))]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }